import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

type StyleEntry =
  | SystemStyleObject<Theme>
  | ((theme: Theme) => SystemStyleObject<Theme>);

export const styles = {
  tableRow: (theme) => ({
    '&:nth-of-type(odd)': {
      backgroundColor:
        theme.palette.mode === 'light'
          ? theme.palette.blue[600]
          : theme.palette.table.row,
    },
    '&.Mui-selected': {
      backgroundColor: `${theme.palette.table.hover} !important`,
      '& .MuiTableCell-body': {
        backgroundColor: `${theme.palette.table.hover} !important`,
      },
    },
  }),
} satisfies Record<string, StyleEntry>;
